/* global $ */

import Router from 'ShopUiBundle/modules/router';

/**
 * Bind events for userrating filter and load more function
 */
function initUserRating() {
  const $loadMoreBtn = $('[data-loadmoreratings]');
  const $concreteIdCheckbox = $('.userrating__actions__checkbox input');
  const $userratingContainer = $('.userrating__listingcontainer');
  const $userrating = $('.userrating__listing');
  const $starRatingFilterButton = $('.userrating__filter__item--button button');
  const abstractId = $('*[data-idproductabstract]').data('idproductabstract');
  // we load as much items are being shown at start
  const ratingLoadLimit = $('.userrating__rating').length;
  const ratingsCount = $userrating.data('ratingsCount');

  function loadContent(filter, loadMore) {

    const filterurl = Router.generate('spryker_review_get', {abstractId}) + '?filter=' + '{'  + filter + '}';

    $.ajax({
      url: filterurl,
      context: document.body,
      beforeSend: () => {
        $userratingContainer.addClass('is-loading');
      },
      success: (html) => {

        if (loadMore === true) {
          // if "load more", we attach the result at the end
          $userrating.append(html);
        } else {
          $userrating.html(html);
        }

        // hide load more button
        const filteredCategories = $('.userrating__filter__list input:checked:not([data-filter-all])');
        const containerList = $userratingContainer.find('.userrating__rating').length;

        if ((filteredCategories.length && containerList <= 10) || (ratingsCount === containerList)) {
          $loadMoreBtn.hide();
        } else {
          $loadMoreBtn.show();
        }

        $userratingContainer.removeClass('is-loading');
      },
      error: () => {
        $userratingContainer.removeClass('is-loading');
      },
    });
  }

  function getFilters(loadMore) {
    let filter = '';
    // Starfilter
    const $checkedInputs = $('.userrating__filter__list input:checked:not([data-filter-all])');
    // if anything is checked
    if ($checkedInputs.length) {
      const checkedValues = [];
      $checkedInputs.each((index, element) => {
        checkedValues.push($(element).val());
      });

      filter += `"starFilter":[${checkedValues}],`;
    }

    if ($concreteIdCheckbox.is(':checked')) {
      const concreteId = $concreteIdCheckbox.val();
      filter += `"concreteId":${concreteId},`;
    }

    if (loadMore === true) {
      // how many items are currently visible
      const offset = $('.userrating__rating').length;
      const limit = ratingLoadLimit;

      filter += `"offset":${offset},"limit":${limit},`;
    }

    // remove the last comma
    filter = filter.substr(0, filter.length - 1);

    return (filter);
  }

  $concreteIdCheckbox.off('change').on('change', () => {
    loadContent(getFilters());
  });

  $starRatingFilterButton.off('click').on('click', () => {
    loadContent(getFilters());

    // close the dropdown
    let button = document.querySelector('.userrating__filter__button, .userrating__filter__dropdown .toggle-dropdown__trigger');

    if(button) {
      button.click();
    }
  });

  // Load More Ratings
  $loadMoreBtn.off('click').on('click', () => {
    loadContent(getFilters(true), true);
  });
}

function bindEvents() {
  if ($('#rating-template').length) {
    initUserRating();
  }
}

/**
 * Exports
 */
export { bindEvents };
